import axios from "axios";
import { API_CLIENT_DOMAIN } from "../constants";
import { handleError } from "../errorHandler";

export const getFileStorageItemDownload = (
  id: number,
  onSuccess: Function,
  onFailure: Function
) => {
  axios
    .get(API_CLIENT_DOMAIN + "/filestorage/" + id + "/download")
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};
